let prefix = '/api/sap/supplier-invoices';

function getAuthInvoices(date1,date2,cardCode){
    return window.axios.get(prefix+'/authorizations_invoices?date1='+date1+'&date2='+date2+'&cardCode='+cardCode);
}
function getInvoicesSupplier(date1, date2){
    return window.axios.get(prefix+'/index?date1='+date1+'&date2='+date2);
}
function getDevolucionIva(date1, date2, DocCur , cardName){
    return window.axios.get(prefix+'/DevolucionIva?date1='+date1+'&date2='+date2+'&DocCur='+DocCur+'&cardName='+cardName);
}
function getDevolucionIvaExport(data){
    return window.axios.post(prefix+'/DevolucionIva/export',data,{ responseType: 'blob' });
}
function getInvoicesSupplierShow(docEntry){
    //console.log(docEntry);
    return window.axios.post(prefix+'/show/'+docEntry);
}
function getReportPurchasesInvoices(docEntry){
    return window.axios.get(prefix+'/reportPurchasesInvoices/'+docEntry);
}

function byArticule(page,perPage,tipo,item) {
    return window.axios.get(prefix+'/byHistory/'+page+'/'+perPage+'?&item='+item+'&tipo='+tipo)
   
}

function getInvoceByitem(page,perPage,date1,date2, item,cardCode) {
    return window.axios.get(prefix+'/getInvoceByitem/'+page+'/'+perPage+'?date1='+date1+'&date2='+date2+'&item='+item+'&cardCode='+cardCode)   
}

function getPurchaseOrder(docEntry){
    return window.axios.get(prefix+'/show/'+docEntry);
}

function getByExpensive(data) {
    return window.axios.post(prefix+'/getExpensiveArticles',{
        //se envian estos paramentros como metodo posts
        startDate: data.date1,
        endDate: data.date2
    })
}

function getByMorePurchased(data) {
    return window.axios.post(prefix+'/getMorePurchasedArticles',{
        startDate: data.date1,
        endDate: data.date2
    })
}

function getByInvoicesMorePurchased(data) {
    return window.axios.post(prefix + '/getInvoicesMorePurchasedArticles', {
        ItemCode: data.Item,
        startDate: data.date1,
        endDate: data.date2
    })
}

export default {
    getAuthInvoices,
    getInvoicesSupplier,
    getDevolucionIva,
    getDevolucionIvaExport,
    getInvoicesSupplierShow,
    getReportPurchasesInvoices,
    byArticule,
    getInvoceByitem,
    getPurchaseOrder,
    getByExpensive,
    getByMorePurchased,
    getByInvoicesMorePurchased
}